import { HtEventsSnippet } from "@ht-sdks/events-sdk-js-browser";
import { isClient } from "src/utils/isClient";

type AnalyticsProps = {
  htevents: HtEventsSnippet;
};

export const getAnalytics = (): {
  htevents: HtEventsSnippet;
} => {
  if (!isClient) {
    return {} as AnalyticsProps;
  }
  return { htevents: window.htevents };
};
